import { useState, useRef, useEffect } from 'react'; 
import { RoundSlider, type ISettingsPointer } from 'mz-react-round-slider';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useGlobalContext } from '../Context/GlobalContext';

const RSlider = (
    { 
        value, 
        setValue, 
        title,
        min,
        max,
        step,
        units
    } : {
        value: number, 
        setValue: Function, 
        title: string,
        min: number,
        max: number,
        step: number,
        units: string
    }
) => {
    const { getThemeStyles } = useGlobalContext(); 
    const styles = getThemeStyles();

    const [ pointers, setPointers ] = useState<ISettingsPointer[]>([
        { value: value },
    ]);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        setPointers([{ value }]);
    }, [value]);

    const update = (pointers: ISettingsPointer[]) => {
        setPointers(pointers);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            setValue(pointers[0].value); 
        }, 500);
    }

    return (
        <div>
            <div className="dial-label">{title}</div>
            <div className="dial-wrapper">
                <RemoveIcon 
                    sx={{ mt: 2, mr: 1, fontSize: '18px', cursor: 'pointer' }}
                    onClick={() => update([{value: Math.max(min, pointers[0].value as number - step)}])}
                />
                <RoundSlider
                    pointers={ pointers }
                    onChange={ (pointers: ISettingsPointer[]) => update(pointers) }
                    pathStartAngle={ 205 }
                    pathEndAngle={ 335 }
                    pathRadius={50}
                    pathBgColor={styles['--theme-color']}
                    connectionBgColor={styles['--theme-color']} 
                    mousewheelDisabled={true} 
                    pointerBgColor={styles['--theme-color']}
                    pointerBgColorSelected={styles['--theme-color']}
                    min={min}
                    max={max}
                    step={step}
                    hideText={true}
                />
                <AddIcon 
                    sx={{ mt: 2, ml: 1, fontSize: '18px', cursor: 'pointer' }}
                    onClick={() => update([{value: Math.min(max, pointers[0].value as number + step)}])}
                />
            </div>
            <div className="dial-label" style={{marginTop: '-40px'}}>{pointers[0].value} {units}</div>
        </div>
    );
};

export default RSlider;